export default __webpack_public_path__ + "static/media/sample_batch_repayment_upload_sheet.25d4d91d.xlsx";